// extracted by mini-css-extract-plugin
export default {"ol":"Home_ol__Ll4dj","ul":"Home_ul__Eu+Fq"};